/**
 * @generated SignedSource<<d9002c0d697d345d76c64fe0f6d5cbf8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type async_softwareReleasesApprovers_Approvers$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesApprovers_Approvers">;
  readonly " $fragmentType": "async_softwareReleasesApprovers_Approvers";
};
export type async_softwareReleasesApprovers_Approvers$key = {
  readonly " $data"?: async_softwareReleasesApprovers_Approvers$data;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesApprovers_Approvers">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "async_softwareReleasesApprovers_Approvers",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesApprovers_Approvers"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "b54447a983203e9751ad03d69a14f12e";

export default node;
